<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
            <page-tool-bar
                :loading="loader"
                show_search
                :search.sync="search"
                show_date_start
                :date_start.sync="date_start"
                show_date_end
                :date_end.sync="date_end"
            >
                <v-flex shrink>
                    <div class="text-right">
                        <v-btn @click="dialog = !dialog" color="green" dark>
                            <v-icon small dark left>add_box</v-icon>
                            Tạo Phiếu Mới
                        </v-btn>
                        <v-btn @click="exportCSV" color="green" class="white--text">XUẤT EXCEL</v-btn>
                        <export-csv-button
                            :trigger="export_csv.trigger"
                            :title="export_csv.title"
                            :rows="export_csv.rows"
                        ></export-csv-button>
                    </div>
                </v-flex>
            </page-tool-bar>
            <v-layout row wrap justify-center>
                <v-flex xs12>
                    <v-card>
                        <v-data-table
                            disable-initial-sort
                            :headers="headers"
                            :items="items"
                            item-key="id"
                            :rows-per-page-items="rowPerPage"
                            :search="search"
                            :loading="loader"
                        >
                            <template #headers="props">
                                <tr>
                                    <th :class="['fw-bold', `text-xs-${header.align}`]" v-for="header in props.headers" :key="header.text">
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template>
                            <template #items="props">
                                <tr>
                                    <td class="text-center text-no-wrap">
                                        <edit-receipt-component @updateCurrentReceipt="updateCurrentReceipt" receipt_type="check_out" title="CHỈNH SỬA PHIẾU TRẢ PHÒNG" :edit_field="edit_field" :selected_receipt="props.item"></edit-receipt-component>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    :disabled="props.item.check_out_type == 2 || !props.item.is_valid"
                                                    class="ma-0"
                                                    v-on="on" flat
                                                    icon color="red"
                                                    @click="cancelCheckOut(props.item)"
                                                >
                                                    <v-icon class="zmdi zmdi-delete"></v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Hủy phiếu báo trả phòng</span>
                                        </v-tooltip>
                                    </td>
                                    <td class="text-center text-no-wrap">{{ props.item.receipt_id }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.date_created | formatTimeServer }}</td>
                                    <!-- <td class="text-center text-no-wrap">{{ props.item.room_state_id }}</td> -->
                                    <td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.date_schedule_out | formatTimeServer }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.date_out | formatTimeServer }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.electric_check_out }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.water_check_out }}</td>
                                </tr>
                            </template>
                            <template #no-data>
                                Chưa có thông tin
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
		</v-container>
		<v-dialog v-model="dialog" persistent max-width="90%">
			<app-card>
                <app-section-loader :status="form_loader"></app-section-loader>
                <v-btn right icon absolute small @click="dialog = false">
                    <v-icon>close</v-icon>
                </v-btn>
                <h4>PHIẾU BÁO TRẢ PHÒNG</h4>
                <p class="fs-14 grey--text">Tạo phiếu báo trả phòng</p>
				<v-form ref="form">
					<v-container fluid>
                        <v-stepper v-model="current_step">
                            <v-stepper-header style="box-shadow: none">
                                <v-stepper-step :complete="current_step > 1" step="1">Nhập phiếu trả phòng</v-stepper-step>
                                <v-divider v-if="form.check_out_type == 2"></v-divider>
                                <v-stepper-step v-if="form.check_out_type == 2" :complete="current_step > 2" step="2">Tính tiền trả cọc</v-stepper-step>
                            </v-stepper-header>
                            <hr class="mt-0">
                            <v-stepper-items>
                                <v-stepper-content step="1">
                                    <p v-if="form.check_out_type == 1" class="fs-14 grey--text">Mã chứng từ: {{ form.receipt_id }}</p>
                                    <v-layout row wrap justify-center>
                                        <v-flex xs12 md3>
                                            <v-select
                                                label="Tòa nhà"
                                                :disabled="loading.submit || form_loader"
                                                v-model="form.building"
                                                :items="list_building"
                                                prepend-icon="domain"
                                                :rules="[rules.required]"
                                                @change="getReceiptNewestNumber"
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-autocomplete
                                                label="Số phòng"
                                                :disabled="loading.submit || form_loader"
                                                v-model="form.room_id"
                                                :items="room_ids"
                                                item-text="room_id"
                                                item-value="rooms_id"
                                                prepend-icon="meeting_room"
                                                :rules="[rules.required]"
                                                @change="getRoomState"
                                            ></v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12 v-if="alert.show">
                                            <v-alert
                                                :value="alert.show"
                                                :type="alert.type"
                                                outline
                                            >
                                                {{ alert.text }}
                                            </v-alert>
                                        </v-flex>
                                        <template v-if="form.room_state_id">
                                            <v-flex v-if="form.check_out_type == 2" xs12 md3>
                                                <v-text-field
                                                    label="Số chứng từ"
                                                    :disabled="true"
                                                    type="text"
                                                    v-model="form.receipt_id"
                                                    prepend-icon="book"
                                                    :rules="[rules.required]"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex v-if="form.check_out_type == 1" xs12 md3>
                                                <v-text-field
                                                    label="Số chứng từ giấy"
                                                    :disabled="loading.submit || form_loader || form.check_out_type == 2"
                                                    type="text"
                                                    v-model="form.paper_receipt_number"
                                                    prepend-icon="book"
                                                    :rules="[rules.required, rules.isNaturalNumber]"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md3>
                                                <v-menu
                                                    :close-on-content-click="false"
                                                    v-model="menu_date_created"
                                                    :nudge-right="40"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                                >
                                                    <v-text-field
                                                        slot="activator"
                                                        v-model="form.date_created"
                                                        label="Ngày tạo phiếu"
                                                        :disabled="loading.submit || form_loader || form.check_out_type == 2"
                                                        prepend-icon="event"
                                                        :rules="[rules.required]"
                                                        readonly
                                                    ></v-text-field>
                                                    <v-date-picker locale="vi-VI" v-model="form.date_created" @input="menu_date_created = false"></v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <v-text-field
                                                    label="Họ tên người đại diện"
                                                    :disabled="loading.submit || form_loader"
                                                    v-model="form.name"
                                                    prepend-icon="account_box"
                                                    :rules="[rules.required]"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <v-text-field
                                                    label="Số điện thoại"
                                                    :disabled="loading.submit || form_loader"
                                                    v-model="form.phone"
                                                    prepend-icon="contact_phone"
                                                    :rules="[rules.required]"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <v-menu
                                                    :close-on-content-click="false"
                                                    v-model="menu_date_schedule_out"
                                                    :nudge-right="40"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                                >
                                                    <v-text-field
                                                        slot="activator"
                                                        v-model="form.date_schedule_out"
                                                        label="Ngày hẹn trả phòng (tính tiền phòng)"
                                                        :disabled="loading.submit || form_loader"
                                                        prepend-icon="event"
                                                        readonly
                                                    ></v-text-field>
                                                    <v-date-picker locale="vi-VI" v-model="form.date_schedule_out" @input="menu_date_schedule_out = false"></v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-flex v-if="form.check_out_type == 2" xs12 md6>
                                                <v-menu
                                                    :close-on-content-click="false"
                                                    v-model="menu_date_out"
                                                    :nudge-right="40"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                                >
                                                    <v-text-field
                                                        slot="activator"
                                                        v-model="form.date_out"
                                                        label="Ngày thực tế trả phòng (tính tiền dịch vụ)"
                                                        :disabled="loading.submit || form_loader"
                                                        prepend-icon="event"
                                                        readonly
                                                    ></v-text-field>
                                                    <v-date-picker locale="vi-VI" v-model="form.date_out" @input="menu_date_out = false"></v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-flex v-if="form.check_out_type == 2" xs12 md3>
                                                <v-text-field
                                                    label="Số điện"
                                                    :disabled="loading.submit || form_loader"
                                                    v-model.number="form.electric_check_out"
                                                    :rules="[rules.required]"
                                                    type="number"
                                                    prepend-icon="receipt"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex v-if="form.check_out_type == 2" xs12 md3>
                                                <v-text-field
                                                    label="Số nước"
                                                    :disabled="loading.submit || form_loader"
                                                    v-model.number="form.water_check_out"
                                                    :rules="[rules.required]"
                                                    type="number"
                                                    prepend-icon="timer"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <v-text-field
                                                    label="Ghi chú"
                                                    :disabled="loading.submit || form_loader"
                                                    v-model="form.note"
                                                    prepend-icon="event_note"
                                                >
                                                </v-text-field>
                                            </v-flex>
                                        </template>
                                    </v-layout>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            v-if="form.check_out_type == 2"
                                            :disabled="loading.calculate || form_loader"
                                            :loading="loading.calculate || form_loader"
                                            @click="calculateReturnDeposit"
                                            color="primary"
                                        >
                                            Tính tiền trả cọc
                                        </v-btn>
                                        <v-btn
                                            v-else
                                            :disabled="loading.submit || form_loader"
                                            :loading="loading.submit || form_loader"
                                            @click="submit"
                                            color="primary"
                                        >
                                            Tạo Phiếu
                                        </v-btn>
                                    </v-card-actions>
                                </v-stepper-content>
                                <v-stepper-content v-if="current_step === 2" step="2">
                                    <v-layout row wrap>
                                        <v-flex xs12 md6>
                                            <div class="text-right mr-5">
                                                <v-btn @click="print_portal = true" color="secondary" flat icon>
                                                    <v-icon class="zmdi zmdi-print"></v-icon>
                                                </v-btn>
                                            </div>
									        <return-deposit-bill-detail :bill="chosen_room" v-if="current_step == 2"></return-deposit-bill-detail>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                            <v-layout row wrap align-content-start>
                                                <v-flex xs12>
                                                    <h3 class="text-center">CHỈNH SỬA</h3>
                                                    <p>Phần này dùng để nhập thêm số tiền phạt khác hoặc chỉnh lại số tiền thực tế trả cọc</p>
                                                </v-flex>
                                                <v-flex v-if="chosen_room.days_from_schedule_out !== undefined" xs12>
                                                    <span>Báo trả cách đây: {{chosen_room.days_from_schedule_out}} ngày</span>
                                                </v-flex>
                                                <v-flex v-if="chosen_room.month_live !== undefined" xs12>
                                                    <span v-if="chosen_room.month_live > 1">Thời gian ở trọ: {{chosen_room.month_live}} tháng</span>
                                                    <span v-if="chosen_room.month_live < 1">Thời gian ở trọ: {{chosen_room.day_live}} ngày</span>
                                                </v-flex>
                                                <v-flex v-if="chosen_room.air_conditioner_month !== undefined" xs12>
                                                    <span v-if="chosen_room.air_conditioner_month > 1">Thời gian sử dụng máy lạnh: {{chosen_room.air_conditioner_month}} tháng</span>
                                                    <span v-if="chosen_room.air_conditioner_month < 1">Thời gian sử dụng máy lạnh: {{chosen_room.air_conditioner_day}} ngày</span>
                                                </v-flex>
                                                <v-flex xs12 md6>
                                                    <v-checkbox
                                                        v-model="fine_obj[1].is_applied"
                                                        class="mt-1"
                                                        hide-details
                                                        color="primary"
                                                        @change="clickFineCheckBox(1)"
                                                    >
                                                        <template v-slot:label>
                                                            <span style="font-size: 15px; color: #464D69">
                                                                Phạt 10 ngày ({{ fine_obj[1].days * chosen_room.room_price / 30 | formatNumber}})
                                                            </span>
                                                        </template>
                                                    </v-checkbox>
                                                </v-flex>
                                                <v-flex xs12 md6>
                                                        <v-checkbox
                                                            v-model="fine_obj[2].is_applied"
                                                            class="mt-1"
                                                            hide-details
                                                            color="primary"
                                                            @change="clickFineCheckBox(2)"
                                                        >
                                                            <template v-slot:label>
                                                                <span style="font-size: 15px; color: #464D69">
                                                                    Phạt chưa đủ 6 tháng ({{ fine_obj[2].amount | formatNumber}})
                                                                </span>
                                                            </template>
                                                        </v-checkbox>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <hr/>
                                                </v-flex>
                                                <v-flex d-flex xs12 md6>
                                                    <v-text-field
                                                        label="Phạt khác:"
                                                        v-model="chosen_room.other_fine_amount"
                                                        required
                                                        v-currency
                                                        prepend-icon="attach_money"
                                                        @change="recalculateReturnDepositAmount"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex d-flex xs12 md6>
                                                    <v-text-field
                                                        label="Tiền nợ các tháng trước:"
                                                        v-model="chosen_room.previous_months_debt"
                                                        v-currency
                                                        prepend-icon="attach_money"
                                                        @change="recalculateReturnDepositAmount"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex d-flex xs12 md6>
                                                    <v-text-field
                                                        label="Số tiền trả cọc:"
                                                        v-model="chosen_room.amount"
                                                        required
                                                        v-currency
                                                        prepend-icon="attach_money"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex d-flex xs12 md12>
                                                    <v-text-field
                                                        label="Ghi chú"
                                                        :disabled="loading.submit || form_loader"
                                                        v-model="chosen_room.note"
                                                        prepend-icon="event_note"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                        color="primary"
                                        :disabled="loading.submit || form_loader"
                                        :loading="loading.submit || form_loader"
                                        @click="submit"
                                        >
                                        Tạo Phiếu
                                        </v-btn>
                                        <v-btn @click="current_step--">Trở Về</v-btn>
                                    </v-card-actions>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
					</v-container>
				</v-form>
			</app-card>
		</v-dialog>

        <print-portal :open="print_portal" @close="print_portal = false">
            <return-deposit-bill-detail :bill="chosen_room"></return-deposit-bill-detail>
        </print-portal>
	</div>
</template>
<script>
import api from "Api";
import moment from 'moment'
import { buildParamQuery, formatTimeServer, deepCopy, parseCurrency } from 'Helpers'
import { calculateRoomBill, getLastDateOfChosenMonth, calculateRoomBillWithDebts, roundToNearestThousand } from '../../functions'
import ReturnDepositBillDetail from 'Components/Bill/ReturnDepositBillDetail'
import EditReceiptComponent from 'Components/Phieu/EditReceiptComponent'
import { list_building } from 'Constants/db-config'
import PrintPortal from 'Components/Print/PrintPortal'
import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton'

export default {
    name: 'PhieuBaoTraPhong',
    components: {
        ReturnDepositBillDetail,
        EditReceiptComponent,
        PrintPortal,
        ExportCsvButton
    },
    data() {
        return {
			dialog: false,
			rules: {
				required: value => !!value || 'Vui lòng điền thông tin này.',
                isNaturalNumber: value =>  /^[1-9]\d*$/.test(value.replace(/,/g, '')) || "Mã chứng từ phải là số",
			},
            form: {
                receipt_id: '',
                paper_receipt_number: '',
                name:'',
                phone: '',
                building: '',
                room_id: '',
                date_out: '',
                date_created: '',
                date_schedule_out: '',
                note: '',
                electric_check_out: 0,
                water_check_out: 0,
                check_out_type: 1,
                room_state_id: ''
            },
            menu_date_created: false,
            menu_date_out: false,
            menu_date_schedule_out: false,
            list_building,
            loader: false,
            headers: [
                { text: "Thao tác", align: "center", sortable: false },
                { text: "#Chứng từ", align: "center", sortable: false, value: "receipt_id" },
                {text: "Ngày tạo", align: "center", sortable: false, value: "date_created"},
                // {text: "Mã quản lý", align: "center", sortable: false, value: "room_state_id"},
                {text: "Số phòng", align: "center", sortable: false, value: "room_id"},
                {text: "Ngày báo trả", align: "center", sortable: false, value: "date_schedule_out"},
                {text: "Ngày thực trả", align: "center", sortable: false, value: "date_out"},
                {text: "Số điện", align: "center", sortable: false, value: "electric_check_out"},
                {text: "Số nước", align: "center", sortable: false, value: "water_check_out"},
            ],
            items: [],
            loading: {
                submit: false,
                calculate: false,
            },
            alert: {
                show: false,
                text: '',
                type: 'error'
            },
            form_loader: false,
			current_step: 1,
			chosen_room_state: {},
			chosen_room: {},
            show_detail_table: false,
            chosen_building: 'BN',
            list_search_type: [
                { text: 'Số phòng', value: 'roomId' },
                { text: 'Mã số phiếu', value: 'receiptId' },
                { text: 'Mã quản lý', value: 'roomStateId' },
                { text: 'Tên khách hàng', value: 'name' },
            ],
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
            menu_date_start: false,
            menu_date_end: false,
            date_start: moment().startOf('month').format('YYYY-MM-DD'),
            date_end: new Date().toISOString().substring(0, 10),
            search:'',
            search_type: 'roomId',
            fine_obj: {
                '0': {
                    text: 'Không phạt',
                    amount: 0,
                    days: 0,
                },
                '1': {
                    text: 'Trả phòng đột ngột phạt 10 ngày',
                    amount: 0,
                    days: 10,
                    is_applied: false
                },
                '2': {
                    text: 'Phòng ở chưa đủ 6 tháng',
                    amount: 500000,
                    amount_text: "500,000",
                    days: 0,
                    is_applied: false
                }
            },
            edit_field: {
                receipt_id: {
                    type: "text",
                    flex_attr: "xs12 sm4",
                    label: "Mã chứng từ",
                    disabled: true,
                    prepend_icon: "receipt",
                    rule: "require"
                },
                date_created: {
                    type: "date",
                    flex_attr: "xs12 sm4",
                    label: "Ngày tạo phiếu",
                    disabled: false,
                    prepend_icon: "event",
                    rule: "require"
                },
                date_schedule_out: {
                    type: "date",
                    flex_attr: "xs12 sm4",
                    label: "Ngày hẹn trả phòng",
                    disabled: false,
                    prepend_icon: "event",
                    rule: "require"
                },
                name: {
                    type: "text",
                    flex_attr: "xs12 sm4",
                    label: "Họ tên",
                    disabled: false,
                    prepend_icon: "account_box",
                    rule: "require"
                },
                phone: {
                    type: "text",
                    flex_attr: "xs12 sm4",
                    label: "Số điện thoại",
                    disabled: false,
                    prepend_icon: "contact_phone",
                    rule: "requirePhone"
                },
                edit_note: {
                    type: "text",
                    flex_attr: "xs12 sm4",
                    label: "Giải thích chỉnh sửa",
                    disabled: false,
                    prepend_icon: "event_note",
                    rule: "require"
                },
            },
            print_portal: false,
            export_csv: {
                trigger: false,
                title: '',
                rows: [],
                loading: false,
            },
        }
	},
    computed: {
        rooms(){
            return this.$store.state.app.rooms
        },
        room_ids(){
            return this.rooms.filter( room => room.building === this.form.building)
        }
    },
    watch: {
        date_start: function(nv){
            if (nv && this.date_end) this.getData()
        },
        date_end: function(nv){
            if (nv && this.date_start) this.getData()
        },
        "form.building": function(nv, ov) {
            if (nv) {
                if (this.form.paper_receipt_number) this.form.receipt_id = nv + '.' + this.form.paper_receipt_number + ".TP";
            }
        },
        "form.paper_receipt_number": function(nv, ov) {
            if (nv && this.form.building) {
                this.form.receipt_id = this.form.building + '.' + nv + ".TP"; 
            }
        },
    },
    created(){
        this.getData()
    },
    methods: {
        validate: function (type){
			// type == 0 => validate form.check_out_type == 1
			// type == 1 => validate form.check_out_type == 2 && step 1 
			if (type == 1){
                if (!this.$refs.form.validate()) {
                    swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                    return false
                }
			}
			// type == 1 => validate form.check_out_type == 2 && step 2 
            return true
        },
        clearInput: function (){
            this.$refs.form.reset()
            this.form.room_state_id = ''
            this.form.contract_id = ''
			this.current_step = 1
			this.chosen_room_state = {}
			this.chosen_room = {}
            this.show_detail_table = false
        },
        getReceiptNewestNumber: async function (){
            return true
            this.form.receipt_id = this.form.building + '-1'
            this.form_loader = true
            const params = {
                receiptType: 'DEPOSIT',
                building: this.form.building
            }
            const query = buildParamQuery(params)
            const data = await api.getReceiptNumberNewest(query)
            if (data.status == 200 && data.data){
                const deposit_array = data.data.deposit
                if (deposit_array && deposit_array.length){
                    this.form.receipt_id = this.form.building + '-' + (Number(deposit_array[0].maxNumber) + 1)
                }
            }
            this.form_loader = false

        },
        getData: async function (){
            this.items = []
			const params = {
                // building: this.chosen_building,
                // [this.search_type]: this.search,
                dateStart: this.date_start,
                dateEnd: this.date_end,
            }
            const query = buildParamQuery(params)
            this.loader = true
            const data = await api.getListCheckOut(query)
            this.loader = false
            if (data.status === 200) {
                // Filter out canceled receipts (is_valid: false)
                this.items = data.data.filter(receipt => receipt.is_valid !== false);
            }
        },
        getRoomState: async function (){
            this.form_loader = true
            this.alert.show = false
            this.form.name = '',
            this.form.phone = '',
            this.form.date_out = '',
            this.form.date_created = '',
            this.form.date_schedule_out = '',
            this.form.note = '',
            this.form.electric_check_out = 0,
            this.form.water_check_out = 0,
            this.form.check_out_type = 1,
            this.form.room_state_id = ''
            // const data = await api.getRoomState( "roomId=" + this.form.room_id )
            const data = await api.getTwoNewestRoomStateEachRoom( "roomId=" + this.form.room_id );
            if (data.status == 200 && data.data && data.data.length){
                const room_data = data.data[0]
                this.chosen_room_state =  room_data.old_room_state && !room_data.old_room_state.date_out
                    ? room_data.old_room_state
                    : room_data.current_room_state
                if ( !this.chosen_room_state || !this.chosen_room_state.is_valid || !this.chosen_room_state.room_state_id || !this.chosen_room_state.check_in_id) {
                    this.form.room_state_id = null
                    this.alert.show = true
                    this.alert.text = `Phòng ${ this.form.room_id } hiện không thể tạo phiếu trả phòng, vui lòng kiểm tra lại thông tin phòng`
                } else {
                    this.form.room_state_id = this.chosen_room_state.room_state_id
                    this.form.contract_id = this.chosen_room_state.contract_id
                    this.form.name = this.chosen_room_state.name
                    this.form.phone = this.chosen_room_state.phone
                    if (this.chosen_room_state.date_schedule_out){
                        const last_check_out = await await api.getListCheckOut(`roomStateId=${this.form.room_state_id}`)
                        this.form.date_schedule_out = last_check_out.data[0].date_schedule_out.substr(0, 10)
                        this.form.date_out = last_check_out.data[0].date_schedule_out.substr(0, 10)
                        this.form.receipt_id = last_check_out.data[0].receipt_id
                        this.form.date_created = last_check_out.data[0].date_created.substr(0, 10)
                        this.form.check_out_type = 2
                    }
				}
            } else {
                this.alert.show = true
                this.alert.text = data.message ? data.message : `Phòng ${ this.form.room_id } hiện không thể tạo phiếu trả phòng, vui lòng kiểm tra lại thông tin phòng`
            }
            this.form_loader = false
        },
        submit: async function () {
            if (!this.validate(this.current_step)) {
                console.log('Lỗi validate');
                return
            }
            this.loading.submit = true
            this.form_loader = true
            let postData = Object.assign({}, this.form)
            postData.date_created = new Date(postData.date_created)
            postData.date_out = postData.date_out ? new Date(postData.date_out) : null
            postData.date_schedule_out = new Date(postData.date_schedule_out)
            if (postData.check_out_type == 1){
                delete postData.date_out
            } else {
				postData.return_deposit = deepCopy(this.chosen_room)
                postData.return_deposit.amount = parseCurrency(postData.return_deposit.amount,  "vi-VN", 'VND')
                postData.return_deposit.other_fine_amount = parseCurrency(postData.return_deposit.other_fine_amount,  "vi-VN", 'VND')
                postData.return_deposit.previous_months_debt = parseCurrency(postData.return_deposit.previous_months_debt,  "vi-VN", 'VND')
                delete postData.return_deposit.createdAt;
                delete postData.return_deposit.debt_details_full_tmp;
            }
            let data = await api.createCheckOut(postData)
            this.loading.submit = false
            this.form_loader = false
            if (data.status == 200){
                this.dialog = false
                this.clearInput()
                this.$store.dispatch("getListRooms");
                this.getData()

                swal.fire('Thành công', 'Tạo phiếu bảo trả phòng thành công', 'success')
            } else {
                swal.fire('Lỗi', data.message, 'error')
            }
        },
        calculateReturnDeposit: async function (){
			this.chosen_room = {}
            // Validate form
			if (!this.validate(this.current_step)) {
                console.log('Lỗi validate');
                return
            }
            // Tính tổng số tiền deposit
            // let list_deposit = await api.getDepositReceipts('roomStateId=' + this.form.room_state_id)
            const paramsReturnDeposit = {
                roomStateId: this.form.room_state_id,
                checkOutDate: this.form.date_out,
            }
            const paramsDebtPayment = {
                roomStateId: this.form.room_state_id,
                isDebt: true
            }
            const checkoutDate = new Date(this.form.date_out);
            checkoutDate.setDate(1); // Tránh lỗi tháng không có ngày 31 nhảy sang tháng sau
            checkoutDate.setMonth(checkoutDate.getMonth() - 1);
            const chosen_month = moment(checkoutDate.toISOString()).format("YYYY-MM")        
			const last_date_of_month = getLastDateOfChosenMonth(chosen_month);
            const paramsChargeRoom = {
				lastDateOfMonth: last_date_of_month.clone().endOf("month").toISOString(),
				roomStateId: this.form.room_state_id,
            }

            const paramsAdjustments = {
				paymentMonth: chosen_month,
				roomStateId: this.form.room_state_id,
            }
            const queryReturnDeposit = buildParamQuery(paramsReturnDeposit)
            const queryDebtPayment = buildParamQuery(paramsDebtPayment)
            const queryChargeRoom = buildParamQuery(paramsChargeRoom)
            const queryAdjustments = buildParamQuery(paramsAdjustments)

            this.loading.calculate = true;
			// Tính tiền phòng cho đến thời điểm hiện tại
            const promise_result = await Promise.all([api.getRoomDataForReturnDeposit(queryReturnDeposit), api.getRoomPayments(queryDebtPayment), api.getChargeRoom(queryChargeRoom), api.findAdjustment(queryAdjustments)]);
            const room_data = promise_result[0]
            const room_debt = promise_result[1]
            const last_month_payment = promise_result[2];
            const last_month_adjustments = promise_result[3];
            this.loading.calculate = false;

			if (room_data.status == 200){
                const payment_data = room_data.data.paymentData[0]
                const electric_water_analyze = this.analyzeElectricWater(payment_data)
                payment_data.electric = [this.analyzeElectricWater(payment_data, "E")]
                payment_data.water = [this.analyzeElectricWater(payment_data, "W")]
				payment_data.electric.unshift({
					building: this.chosen_room_state.building,
					contract_id: this.chosen_room_state.contract_id,
					createdAt: new Date().toISOString(),
					date_check: this.form.date_out,
					room_id: this.chosen_room_state.room_id,
					type: "E",
					count: this.form.electric_check_out
				})
				payment_data.water.unshift({
					building: this.chosen_room_state.building,
					contract_id: this.chosen_room_state.contract_id,
					createdAt: new Date().toISOString(),
					date_check: this.form.date_out,
					room_id: this.chosen_room_state.room_id,
					type: "W",
					count: this.form.water_check_out
                })
                const date_calc_room_bill = moment(this.form.date_out).diff(moment(this.form.date_schedule_out), 'days') > 0 ? this.form.date_out : this.form.date_schedule_out;

                const lastMonthPayment = last_month_payment.data.paymentData[0];

                const adjustmentAmount = last_month_adjustments.data.reduce((acc, cur) => acc + cur.amount, 0);

                // kiểm tra xem có phải TH cộng gộp nợ của tháng check-in vào hay không
                const is_checkin_and_checkout_in_the_same_month = moment(this.form.date_out).format('YYYY-MM') === moment(payment_data.date_in).format('YYYY-MM');
                const is_include_checkin_month_debt = is_checkin_and_checkout_in_the_same_month || (lastMonthPayment && lastMonthPayment.date_in && 
                    moment(this.form.date_out).format('YYYY-MM') === moment(lastMonthPayment.date_in).add(1, 'month').format('YYYY-MM') && (lastMonthPayment.collected_amount < lastMonthPayment.total_bill + adjustmentAmount));

                const internetResponse = await api.getListInternet();
                const allInternetUsers = internetResponse.status === 200 && internetResponse.data && internetResponse.data.internet 
					? internetResponse.data.internet 
					: null;
                // Lấy tất cả price history một lần
                let allPriceHistory = {};
                try {
                    const historyResponse = await api.getInternetPriceHistory();
                    if (historyResponse.status === 200 && historyResponse.data && historyResponse.data.data) {
                        // Group theo internet_id
                        historyResponse.data.data.forEach(history => {
                            const internetId = history.internet_id;
                            if (!allPriceHistory[internetId]) {
                                allPriceHistory[internetId] = [];
                            }
                            allPriceHistory[internetId].push(history);
                        });
                    }
                } catch (error) {
                    console.error('Lỗi lấy lịch sử giá:', error);
                }
                const room_payment = await calculateRoomBill(payment_data, this.form.date_out.substr(0, 7), this.form.date_out, date_calc_room_bill, true, is_include_checkin_month_debt ? (is_checkin_and_checkout_in_the_same_month ? 0 : lastMonthPayment.date_count) : 0, allInternetUsers, allPriceHistory)

                room_payment.is_checkin_and_checkout_in_the_same_month = is_checkin_and_checkout_in_the_same_month;
                room_payment.is_include_checkin_month_debt = is_include_checkin_month_debt;

                if (lastMonthPayment) {
                    room_payment.last_month_payment = lastMonthPayment;
                    room_payment.bill_paid_amount = lastMonthPayment.collected_amount;

                    if (room_payment.last_month_payment.collected_amount < room_payment.last_month_payment.total_bill + adjustmentAmount) {
                        if (is_include_checkin_month_debt) {
                            room_payment.bill_paid_amount = room_payment.room_price;
                        } else {
                            room_payment.bill_paid_amount = room_payment.last_month_payment.collected_amount < room_payment.room_price ? room_payment.last_month_payment.collected_amount : room_payment.room_price;
                        }
                    } else {
                        room_payment.bill_paid_amount = room_payment.room_price;
                    }
                } else if (is_include_checkin_month_debt) {
                    room_payment.bill_paid_amount = room_payment.room_price;
                } else {
                    room_payment.bill_paid_amount = 0;
                }

                room_payment.date_out = room_payment.date_out || this.form.date_out;
                    
                const deposits = this.chosen_room_state.deposits
                const total_deposit =  deposits.reduce(
                    (accu, deposit)=> accu += (Number(deposit.deposit_amount) || 0),
                0)

                // Phạt trả sớm:
                this.analyzeFine(payment_data, room_payment)

                // Tính nợ
                room_payment.debt_amount = this.calculateRoomDebt(room_debt)
                room_payment.debt_months = [];
                room_payment.debt_details = [];
                room_payment.debt_details_full_tmp = [];

                const filteredRoomDebt = room_debt.data.find(payment => payment.month === chosen_month);

                filteredRoomDebt && [filteredRoomDebt].forEach(payment => {
                    if ( payment.collected_amount < payment.total_bill + adjustmentAmount && !payment.is_approved ) {
                        room_payment.debt_months.push(payment.month)
                        room_payment.debt_details.push({
                            month: payment.month,
                            debt_amount: payment.total_bill + adjustmentAmount -  payment.collected_amount
                        })
                        room_payment.debt_details_full_tmp.push(payment);
                    }
                })

                room_payment.room_bill_with_debts = calculateRoomBillWithDebts(room_payment); // dùng để hiển thị thông tin hóa đơn theo format mới

                room_payment.deposit_amount = room_payment.deposit_status ? room_payment.deposit_price : total_deposit;
                room_payment.computed_amount = roundToNearestThousand(room_payment.deposit_amount + room_payment.bill_paid_amount - room_payment.room_bill_with_debts.total_bill - room_payment.fine_amount);
                room_payment.amount = room_payment.computed_amount;
                room_payment.other_fine_amount = 0;
                room_payment.previous_months_debt = 0;

                this.chosen_room = deepCopy(room_payment)
                this.chosen_room.date_out = this.form.date_out
                this.chosen_room.date_schedule_out = this.form.date_schedule_out
                this.chosen_room.month = this.form.date_out.substr(0, 7)
                this.chosen_room.total_deposit = total_deposit
                this.chosen_room.debt_amount = room_payment.debt_amount
                this.chosen_room.computed_room_price = this.chosen_room.room_price
                this.chosen_room.computed_total_bill = this.chosen_room.total_bill
                this.chosen_room.computed_total_deposit = this.chosen_room.total_deposit
                this.chosen_room.computed_deposit_price = this.chosen_room.deposit_price
                this.chosen_room.computed_fine_amount = this.chosen_room.fine_amount
                this.chosen_room.computed_fine_status_text = this.chosen_room.fine_status_text
                this.chosen_room.computed_bill_paid_amount = this.chosen_room.bill_paid_amount
			}

            this.current_step = 2
        },
        calculateRoomDebt: function (room_debt){
            let debt = 0
            room_debt.data.forEach(payment => {
                if ( payment.collected_amount < payment.total_bill && !payment.is_approved ){
                    debt += payment.total_bill -  payment.collected_amount
                }
            })
            return debt
        },
        removeCheckOutFromTable: function (receipt_id){
            const index = this.items.findIndex(receipt => receipt.receipt_id === receipt_id)
            this.items.splice(index, 1)
        },
        updateCheckoutStatus: function (receipt_id){
            const receipt = this.items.find(receipt => receipt.receipt_id === receipt_id)
            if (receipt){
                receipt.is_valid = false
            } else console.log('Lỗi ko tìm dc recept');
        },
        cancelCheckOut: async function (check_out_receipt){
            let that = this
            swal.fire({
            title: 'Hủy Phiếu báo trả phòng',
            html: `<p>Bạn có chắc muốn hủy phiếu báo trả phòng:</p><p>Mã chứng từ: <span style="color: #464D69; font-weight: bold;">${check_out_receipt.receipt_id}</span></p><p>Số phòng: <span style="color: #464D69; font-weight: bold;">${check_out_receipt.room_id}</span></p>`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Hủy phiếu này',
            cancelButtonText: 'Trở về'
            }).then(async (result) => {
                if (result.value) {
                    const postData = {
                        receipt_id: check_out_receipt.receipt_id,
                        room_state_id: check_out_receipt.room_state_id
                    }
                    let data = await api.cancelCheckOut(postData)
                    if (data.status == 200){
                        swal.fire('Thành công', `Đã hủy thành công phiếu số ${check_out_receipt.receipt_id}`, 'success')
                        that.removeCheckOutFromTable(check_out_receipt.receipt_id)
                    } else {
                        swal.fire('Lỗi', data.message, 'error')
                    }
                }
            })
        },
        updateCurrentReceipt(_id, updated_field){
            const selected_receipt = this.items.find(receipt => receipt._id === _id);
            for (const key in updated_field) {
                if (updated_field.hasOwnProperty(key)) {
                    const element = updated_field[key];
                    selected_receipt[key] = element;
                }
            }
        },
        recalculateReturnDepositAmount: function (){
            // this.chosen_room.amount = this.chosen_room.computed_amount
            const computed_amount = parseCurrency(this.chosen_room.computed_amount,  "vi-VN", 'VND')
            let other_fine_amount = parseCurrency(this.chosen_room.other_fine_amount,  "vi-VN", 'VND')
            let previous_months_debt = parseCurrency(this.chosen_room.previous_months_debt,  "vi-VN", 'VND')
            this.chosen_room.amount = (computed_amount - other_fine_amount - previous_months_debt).toLocaleString('vi-VI') + " ₫"
        },
        analyzeElectricWater: function (data, type){
            const arr = type == "E" ? data.electric : data.water
            const el_0 = arr[0]
            const month_check = el_0.date_check.substr(0, 7)
            const month_out = this.form.date_out.substr(0, 7)

            if (month_check == month_out && !el_0.check_in_id){
                return arr[1]
            } else return el_0
        },
        analyzeFine: function (payment_data, room_payment){
            this.fine_obj[1].is_applied = false;
            this.fine_obj[2].is_applied = false;

            const last_check_out_receipt = payment_data.check_outs[0]
            const lastest_checkout_date = last_check_out_receipt && last_check_out_receipt.date_created ? last_check_out_receipt.date_created.substr(0, 10) : new Date();

            room_payment.day_live = moment(this.form.date_out).diff(moment(room_payment.date_in), 'days')
            room_payment.month_live = moment(this.form.date_out).diff(moment(room_payment.date_in), 'months')
            room_payment.days_from_schedule_out = moment(this.form.date_out).diff(moment(lastest_checkout_date), 'days')


            if ( room_payment.days_from_schedule_out < 10 ) {
                room_payment.fine_status = 1;
                this.fine_obj[1].is_applied = true;
            } else if (room_payment.month_live < 6) {
                room_payment.fine_status = 2;
                this.fine_obj[2].is_applied = true;
            } else room_payment.fine_status = 0
            // Phạt trả máy lạnh sớm

            if ( !room_payment.is_included_air_conditioner && room_payment.air_conditioner && room_payment.air_conditioner.data && room_payment.air_conditioner.data.length ) {
                const date_start = room_payment.air_conditioner.data[0].date_start
                room_payment.air_conditioner_month = moment(this.form.date_out).diff(moment(date_start), 'months')
                room_payment.air_conditioner_day = moment(this.form.date_out).diff(moment(date_start), 'days')
            }
            this.calculateFine(room_payment)
        },
        calculateFine: function (room_payment){
            room_payment.fine_amount = this.fine_obj[room_payment.fine_status].days * room_payment.room_price / 30
                + this.fine_obj[room_payment.fine_status].amount
            room_payment.fine_amount = Math.round(room_payment.fine_amount/ 1000) * 1000
            room_payment.fine_status_text = this.fine_obj[room_payment.fine_status].text
        },
        clickFineCheckBox: function (status){
            if (status == 2){
                this.fine_obj[1].is_applied = false;
            } else this.fine_obj[2].is_applied = false;

            const value = this.fine_obj[status].is_applied;

            this.chosen_room.fine_status = value ? status : 0;
            this.calculateFine(this.chosen_room);
            this.chosen_room.computed_amount = roundToNearestThousand(this.chosen_room.deposit_amount + this.chosen_room.bill_paid_amount - this.chosen_room.room_bill_with_debts.total_bill - this.chosen_room.fine_amount)
            this.recalculateReturnDepositAmount()
        },
        exportCSV: function(){
			const rows = this.items.map((item, index) => {
				return {
                    "STT": index + 1,
                    "Mã chứng từ": item.receipt_id,
                    "Ngày tạo": formatTimeServer(item.date_created),
                    "Số phòng": item.room_id,
                    "Ngày báo trả": formatTimeServer(item.date_schedule_out),
                    "Ngày thực trả": formatTimeServer(item.date_out),
                    "Số điện": item.electric_check_out,
                    "Số nước": item.water_check_out,
                }
			})
			this.export_csv.rows = rows;
			const date = new Date().toISOString().substring(0, 10)
			this.export_csv.title = "phieu-bao-tra-phong-" + date;
			this.export_csv.trigger = !this.export_csv.trigger;
		}

    }
};
</script>
